import { isEmpty, isNil, isString, omit } from 'lodash/fp';

import PriceService from '../../../../models/price';

// @ts-expect-error - Automatic, Please fix when editing this file
const getYouthDiscountSavings = ({ customer, frequency, prices, productId, priceOptions }) => {
  if (isEmpty(prices)) {
    return null;
  }

  const priceWithoutDiscount = PriceService.getPrice(prices, productId, omit('members', customer), priceOptions);
  const priceWithDiscount = PriceService.getPrice(prices, productId, customer, priceOptions);
  if (isNil(priceWithoutDiscount) || isNil(priceWithDiscount)) {
    return null;
  }

  const frequencyWithoutDiscount = priceWithoutDiscount?.amount?.[frequency];
  const frequencyWithDiscount = priceWithDiscount?.amount?.[frequency];
  if (!isString(frequencyWithoutDiscount) || !isString(frequencyWithDiscount)) {
    return null;
  }
  // @ts-expect-error - Automatic, Please fix when editing this file
  const savings = frequencyWithoutDiscount - frequencyWithDiscount;
  return Math.max(savings, 0);
};

export default getYouthDiscountSavings;
